import { MateriaInterface } from './../models/materia.model';
import { Injectable } from "@angular/core";
import { ApiService } from './api.service';
import { PaginateData, PaginateOptions } from '../utils/paginate.utils';
import { Observable, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class MateriasService extends ApiService<MateriaInterface> {
  private maxEntries = 200;
  url = "materias";

  getMateriasByNivelModalidad = (idnivel: number, idmodalidad: number) => {
    return this.http.get(`${this.getApiUrl()}/materiaPlan/materias/${idnivel}/${idmodalidad}`);
  }

  getByModalidad = (modalidad_id: number, params?: any, ignoreCache = false): Observable<PaginateData<MateriaInterface>> => {
    const cacheKey = `${JSON.stringify(params)}-modalidad-${modalidad_id}`;
    if (this._getContent.size >= this.maxEntries) {
      const oldestKey = this._getContent.keys().next().value;
      if (typeof oldestKey === 'string') {
        this._getContent.delete(oldestKey);
      }
    }
    if (!this._getContent.get(cacheKey)) {
      this._getContent.set(cacheKey,
        this.http.get(`${this.getApiUrl()}/modalidad/${modalidad_id}`, {
          params
        })
      );
    }
    else if (ignoreCache) {
      this._getContent.delete(cacheKey);
      this._getContent.set(cacheKey,
        this.http.get(`${this.getApiUrl()}/modalidad/${modalidad_id}`, {
          params
        }).pipe(shareReplay())
      );
    }
    return this._getContent.get(cacheKey)!;
  }

  override delete = (id: number) => {
    this._getContent.clear();
    return this.http.delete(`${this.getApiUrl()}/${id}`);
  }

  deleteFromTitulo = (titulo_id: number, materia_id: number, motivo: string, comment: string) => {
    return this.http.delete(`${this.getApiUrl()}/delete/${titulo_id}/${materia_id}`,
      {
        body: { motivo, comment }
      }
    );
  }

  getTitulosByMateria = (paginateOptions: PaginateOptions, materia_id: number, nivel_id: number , ignoreCache = false) => {
    const cacheKey = `${JSON.stringify(paginateOptions)}-materia-${materia_id}-nivel-${nivel_id}`;
    if (this._getContent.size >= this.maxEntries) {
      const oldestKey = this._getContent.keys().next().value;
      if (typeof oldestKey === 'string') {
        this._getContent.delete(oldestKey);
      }
    }
    if (!this._getContent.get(cacheKey)) {
      this._getContent.set(cacheKey,
        this.http.get(`${this.getApiUrl()}/titulos-asociados/${materia_id}/${nivel_id}`, {
          params: { ...paginateOptions }
        }).pipe(shareReplay())
      );
    } else if (ignoreCache) {
      this._getContent.delete(cacheKey);
      this._getContent.set(cacheKey,
        this.http.get(`${this.getApiUrl()}/titulos-asociados/${materia_id}/${nivel_id}`, {
          params: { ...paginateOptions }
        }).pipe(shareReplay())
      );
    }
    return this._getContent.get(cacheKey)!;
  }
  getTitulosActivosByMateria = (paginateOptions: PaginateOptions, materia_id: number, nivel_id: number, ignoreCache = false) => {
    const cacheKey = `${JSON.stringify(paginateOptions)}-materia-${materia_id}-nivel-${nivel_id}`;
    if (this._getContent.size >= this.maxEntries) {
      const oldestKey = this._getContent.keys().next().value;
      if (typeof oldestKey === 'string') {
        this._getContent.delete(oldestKey);
      }
    }
    if (!this._getContent.get(cacheKey)) {
      this._getContent.set(cacheKey,
        this.http.get(`${this.getApiUrl()}/titulos-asociados-activos/${materia_id}/${nivel_id}`, {
          params: { ...paginateOptions }
        }).pipe(shareReplay())
      );
    } else if (ignoreCache) {
      this._getContent.delete(cacheKey);
      this._getContent.set(cacheKey,
        this.http.get(`${this.getApiUrl()}/titulos-asociados-activos/${materia_id}/${nivel_id}`, {
          params: { ...paginateOptions }
        }).pipe(shareReplay())
      );
    }
    return this._getContent.get(cacheKey)!;
  }
}
